import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner } from '#pplx/frontend/aether/components/Spinner/index.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export const SidebarProjectInlineCreateLoading = () => {
    return (_jsxs("div", { className: "h-8 flex items-center px-2", role: "status", children: [_jsx(Spinner, { size: 16, color: "quieter" }), _jsx("span", { className: "sr-only", children: _jsx(FormattedMessage, { defaultMessage: "Loading project editor", description: "Status shown while the inline project editor loads in the sidebar", id: "d7b3a58e88" }) })] }));
};
//# sourceMappingURL=SidebarProjectInlineCreateLoading.js.map